<div class="ui container">
  <div class="ui breadcrumb">
    <a [routerLink]="['/']">
      Bounties List
    </a>
    <i class="right angle icon divider"></i>
    <a [routerLink]="bounty ? ['/bounties/' + bounty.id] : null">
      View Bounty
    </a>
    <i class="right angle icon divider"></i>
    <div class="active section">Claim</div>
  </div>

  <div class="ui stackable grid section" id="page-header-grid">
    <div class="row">
      <div class="left floated sixteen wide column">
        <h1 class="ui inverted header">
          Bounty Claim
          <div *ngIf="isOwner" class="ui blue tag label">
            You are the bounty owner
          </div>
          <div *ngIf="isClaimer" class="ui teal tag label">This
            is your claim</div>
        </h1>

      </div>
    </div>
    <div class="row no-padding">
      <div class="sixteen wide column">
        <div *ngIf="bountyClaim && hasActions" class="ui dropdown icon primary button"
          suiDropdown>
          <div class="text">
            Actions
          </div>
          <i class="ellipsis vertical icon"></i>
          <div class="menu" suiDropdownMenu>
            <div *ngIf="canAccept" class="icon item" (click)="acceptClaim()">
              <i class="green plus icon"></i> Accept Claim
            </div>
            <div *ngIf="canDenyOrCancel" class="icon item"
              (click)="denyClaim()">
              <i class="red times icon"></i>
              {{ isClaimer ? 'Withdraw Claim' : 'Deny Claim'}}
            </div>
            <div *ngIf="canMarkPaymentReceived" class="icon item"
              (click)="markPaymentReceived()">
              <i class="green money icon"></i>
              Mark Payment Received
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!bountyClaim" class="ui basic very padded segment">
    <div class="ui inverted active centered inline huge text loader">
      Loading claim...
    </div>
  </div>

  <div *ngIf="bountyClaim" class="section">
    <div class="ui green message" *ngIf="!isOwner && bountyClaim.status === 'accepted'">
      <div>
        <p *ngIf="bounty.status === 'winner-chosen'">
          Congratulations! Your claim has been accepted. Please
          read the instructions below.
        </p>
        <p *ngIf="bounty.status === 'complete'">
          Your claim was accepted and you have won the bounty.
        </p>
      </div>
    </div>

    <div class="ui message" *ngIf="isOwner && bountyClaim.status === 'accepted'">
      <div>
        <p>
          This claim has been chosen as the winner of the
          bounty!
        </p>
        <div *ngIf="bounty.status === 'winner-chosen'">
          <p>
            Please contact the winner ASAP to send payment. You
            may contact them
            using the messages below or (probably more
            effectively) in-game using their osu username.
          </p>
          <p>
            Please send the reward to the winner within 7 days
            to avoid any disputes.
          </p>
        </div>
      </div>
    </div>

    <table class="ui inverted unstackable table">
      <thead>
        <th>Claimer</th>
        <th>Creator</th>
        <th>Status</th>
        <th class="mobile-hide">Date of submission</th>
        <th class="mobile-hide" align="left">Last updated at:</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <app-user-label [user]="bountyClaim.claimer">
            </app-user-label>
          </td>
          <td>
            <app-user-label [user]="bounty.owner">
            </app-user-label>
          </td>
          <td>
            <div class="ui label" [ngClass]="statusColor">
              {{bountyClaim.status}}
            </div>
          </td>
          <td class="mobile-hide">{{bountyClaim.created_at |
            date:'medium'}} (UTC)</td>
          <td class="mobile-hide">{{bountyClaim.updated_at |
            date:'medium'}} (UTC)</td>
        </tr>
      </tbody>
    </table>


    <div class="ui inverted icon message" *ngIf="bountyClaim && bounty.payment_type === 'pool' && isOwner">
      <i class="info icon"></i>
      <div class="content">
        <p>
          As this bounty has a reward pool, only a site moderator
          can approve this claim.
        </p>
      </div>
    </div>

    <div *ngIf="!isOwner && bounty.status !== 'complete'" class="section ui black icon message">
      <i class="info icon"></i>
      <div class="content">
        <h3>
          What's next?
        </h3>
        <div *ngIf="bounty.status === 'winner-chosen'">
          <p *ngIf="bounty.payment_type !== 'pool'">
            Please contact the bounty creator to arrange payment
            of the reward.
            You may use the messages below to contact the
            creator,
            or contact them in-game,
            however please do not
            include send any sensitive information in your
            messages (e.g. bank details).
          </p>
          <p *ngIf="bounty.payment_type === 'pool'">
            Since the reward is a pool, you must contact a site
            admin to request payment. Payment will be made from
            osustuff
            (not the bounty creator).
          </p>
          <p>
            If you are unable to contact the creator within 7
            days of winning,
            or have not received payment within 30 days, please
            contact a site admin
            to raise a dispute.
          </p>
          <h4>
            Once you have received the reward money, click this
            button:
          </h4>
          <button class="ui green button" (click)="markPaymentReceived()">
            Mark Payment as Received
          </button>
        </div>
        <div *ngIf="bountyClaim.status === 'new'" class="description">
          <p *ngIf="bounty.payment_type !== 'pool'">
            Your claim for this reward has been submitted. You
            must now wait for a website admin
            to accept (or deny) this claim.
          </p>
          <p *ngIf="bounty.payment_type === 'pool'">
            Your claim for this reward has been submitted. You
            must
            now wait for the Creator of the bounty (or an admin)
            to accept
            (or deny) this
            claim.
          </p>
          <p>Please <b>do not share any
              person information in the messages below
            </b> as this page may be seen by moderators of the
            site. Please contact each other
            via some other method (e.g. discord chat) if you
            need to
            discuss payment details.
          </p>
          <p>Remember to mark this bounty as paid once you have
            received the money, in order for the Creator
            to gain points.
          </p>
        </div>
        <div *ngIf="bountyClaim.status === 'denied' || bountyClaim.status === 'withdrawn'">
          <p *ngIf="bountyClaim.status === 'denied'">
            Your claim has been denied by the bounty creator or
            a moderator.
            This is most likely because you have not met the
            requirements, or
            someone else has been claimed the winner.
          </p>
          <p *ngIf="bountyClaim.status === 'withdrawn'">
            Your claim has been withdrawn. You may submit
            another claim if you wish to do so.
          </p>
        </div>
      </div>
    </div>

    <app-comments-section [comments]="bountyClaim.comments"
      [resourceName]="'claims'" [id]="bountyClaim.id" (refetch)="fetch()"
      [ownerId]="bounty.user_id">
    </app-comments-section>
  </div>
</div>
